import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { Colours } from '../../tokens';
const useStyles = createUseStyles(() => ({
    root: {
        display: 'flex',
        columnGap: 8,
        backgroundColor: Colours.septernary,
        borderRadius: 10,
        padding: 4,
        justifyContent: 'space-between',
        overflowX: 'auto',
    },
}));
function TabList({ children, className, }) {
    const classes = useStyles();
    return (React.createElement("div", { role: "tablist", className: classNames(className, classes.root) }, children));
}
export default TabList;
//# sourceMappingURL=TabList.js.map